<template>
  <v-card
    border
    class="rounded-lg"
  >
    <div
      style="height: 170px"
      class="blue-grey lighten-5 pa-0 position-relative material-card-image"
    >
      <div class="material-card__preview-actions">
        <button
          class="material-card__preview-actions-button"
          @click="$emit('preview')"
        >
          <v-icon
            icon="mdi-magnify-plus-outline"
            color="primary"
            size="24"
          />
        </button>
      </div>
      <div
        v-if="icon && (showIcon || !optimizedThumbnailUrl)"
        class="pa-10"
      >
        <r-img
          :src="icon"
          height="100px"
        />
      </div>
      <r-img
        v-else
        :src="optimizedThumbnailUrl"
        class="bg-grey-lighten-3"
        height="170px"
        @error="handleImageError"
      />
      <v-chip
        v-if="isNew"
        color="primary"
        size="small"
        variant="elevated"
        rounded
        class="position-absolute top-0 right-0 ma-2"
      >
        {{ $t('labels.new') }}
      </v-chip>
    </div>

    <v-divider />
    <v-tooltip
      location="top"
      v-if="caption"
    >
      <template v-slot:activator="{ props }">
        <span
          v-bind="props"
          class="text-truncate w-100 text-caption px-2"
          v-text="caption"
        />
      </template>
      <span>{{ caption }}</span>
    </v-tooltip>

    <v-card-actions
      class="white py-1"
      :style="{ 'margin-top': caption ? '-18px' : undefined }"
    >
      <v-tooltip location="top">
        <template v-slot:activator="{ props }">
          <span
            v-bind="props"
            class="flex-grow-1 text-truncate"
            v-text="name"
          />
        </template>
        <span>{{ name }}</span>
      </v-tooltip>

      <v-tooltip location="top">
        {{ $t('tooltips.create-marketing-content') }}
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            v-if="topicId && imageId && imageSource"
            icon
            :to="{
              name: 'content-creator',
              hash: '#creator',
              query: { topicId, imageId, imageSource },
            }"
          >
            <v-icon>mdi-brain</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
      <v-tooltip location="top">
        {{ $t('tooltips.download') }}
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            icon
            :href="url"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
import { setQueryParams } from '@/lib/url'

export default {
  emits: ['preview'],
  props: {
    caption: { type: String, default: '' },
    name: { type: String, default: '' },
    url: { type: String, required: true },
    icon: { type: String, default: '' },
    thumbnailUrl: { type: String, default: '' },
    topicId: { type: String, default: '' },
    imageId: { type: String, default: '' },
    isNew: { type: Boolean, default: false },
    imageSource: { type: String, default: '' },
  },

  data() {
    return {
      showIcon: false,
    }
  },

  computed: {
    optimizedThumbnailUrl() {
      if (this.thumbnailUrl) {
        return this.setQueryParams(this.thumbnailUrl, { h: 340 })
      }
      return null
    },
  },
  methods: {
    setQueryParams,
    handleImageError() {
      this.showIcon = true
    },
  },
}
</script>
<style scoped>
.v-card-actions {
  gap: unset;
}
.v-btn {
  padding-left: 0;
  padding-right: 0;
  width: calc(var(--v-btn-height));
}
.text-caption {
  font-style: italic;
}

.material-card__preview-actions {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.material-card__preview-actions-button {
  background: white !important;
  border-radius: 100%;
  padding: 8px;
}

.material-card__preview-actions-button:focus-visible {
  outline: none;
}

.material-card-image:hover .material-card__preview-actions,
.material-card-image:focus-within .material-card__preview-actions {
  opacity: 1;
}
</style>
